const DEFAULT_SUBREDDIT = 'javascript';

export default DEFAULT_SUBREDDIT;
